import React, { useEffect, useState } from 'react';

import { AxiosError } from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { response } from '../../../api/db';
import { verifyMemberEmail } from '../../../api/db/member';
import { common } from '../../../modules/error';

import CustomLoading from '../../uiParts/CustomLoading';
import Header from '../../uiParts/Header';
import { sentryLog } from '../../../config/sentry';

const MemberConfirmEmail = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const confirmationToken = searchParams.get('token');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const response = await verifyMemberEmail(confirmationToken);
        navigate('/auth/member/register/info', {
          state: {
            email: response.data.email,
            id: response.data.id,
            token: confirmationToken
          }
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (error: any) {
        sentryLog(error);
        const axiosError = error as AxiosError;
        if (axiosError.isAxiosError && axiosError.response) {
          const loginErrorResponse = axiosError.response as response;
          navigate('/auth/login', {
            state: { error: loginErrorResponse.data.message }
          });
        } else {
          navigate('/auth/login', { state: { error: common } });
        }
      } finally {
        setLoading(false);
      }
    })();
  }, [confirmationToken]);

  return (
    <>
      <CustomLoading loading={loading} />
      <Header />
    </>
  );
};

export default MemberConfirmEmail;
